<template>
  <div>
    <div elevation="0" color="transparent" flat>
      <div class="row mb-8">
        <div class="col-6 d-flex justify-content-start">
          <v-card-title>
            {{ $t('routes.products') }}
          </v-card-title>
        </div>
        <div class="col-6 d-flex justify-content-end  gap-2">
          <!-- Bouton pour ouvrir le dialogue de filtre -->
          <genericBtnComponent @click="openFilterDialog" svg="4" Title="" class="ml-2" />
          <genericBtnComponent :ClickFun="navigateToNewProduct" svg="2" :Title="$t('products.add')">
          </genericBtnComponent>
        </div>
      </div>
    </div>
    <v-card elevation="0">
      <products-list :productsList="productsdata" ref=ProductListRef />
    </v-card>
    <product-filter-dialog :dialogFilter="dialogFilter" v-model="dialogFilter" v-model:no="dialogFilter"
      :filterParams="filterParams" :categoryOptions="categoryOptions" :statusOptions="statusOptions"
      :availabilityOptions="availabilityOptions" @apply-filter="applyFilter" @close-filter="closeFilterDialog"
      @update:dialogFilter="dialogFilter = $event" @clear="clearProducts" />
  </div>
</template>
<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import ProductsList from "@/components/products/ProductsList.vue";
import ProductFilterDialog from "@/components/products/ProductFilterDialog.vue";
import { GetMaxPrice } from "@/api/index";

export default {
  components: {
    ProductsList,
    genericBtnComponent,
    ProductFilterDialog,
  },
  mounted() {
    document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.products');
    this.fetchMaxPrice();
  },
  computed: {
    productsdata() {
      return this.products
    }
  },
  data() {
    return {
      maxPriceLimit: 0,
      width: 800,
      products: [],
      dialogFilter: false, // Contrôle l'ouverture/fermeture du dialogue de filtre
      filters: {}, // Filtres appliqués à la liste des produits
      filterParams: {
        productName: '',
        category: null,
        status: "",
        availability: null,
        sku: '',
        creationDate: [], // Plage de dates pour la création
        priceRange: [0, this.maxPriceLimit], // Intervalle de prix min/max
      },
      categories: [],
      statusOptions: ['Activated', 'Deactivated'],
      availabilityOptions: ['En stock', 'Épuisé'],
    };
  },
  methods: {
    fetchMaxPrice() {
      GetMaxPrice()
        .then((response) => {
          this.maxPriceLimit = response.data; // Stocke le prix maximum dans maxPriceLimit
          this.filterParams.priceRange[1] = this.maxPriceLimit // Initialise la valeur maximale du slider
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération du prix maximum :", error);
        });
    },
    clearProducts() {
      this.$refs.ProductListRef.updateFilter(this.filterParams)
      //this.$refs.ProductListRef.applyFilter(this.filterParams)
      this.dialogFilter = false;
    },
    navigateToNewProduct() {
      this.$router.push({ name: 'NewProduct' });
    },
    openFilterDialog() {
      this.dialogFilter = true;
    },
    closeFilterDialog() {
      this.dialogFilter = false;
    },
    applyFilter(filterParams) {
      this.$refs.ProductListRef.updateFilter(filterParams)
    }
  },
}
</script>
<style scoped>
.v-card-title {
  font-size: 14px;
  font-family: inter;
  font-weight: 600;
}

.v-card-title {
  color: #001e50;
  font-size: 18px;
  line-height: 25.5px;
  font-weight: 700;
  font-family: inter;
}
</style>